import { sql } from "drizzle-orm";
import { pgTable, serial, text, integer, timestamp, index, uniqueIndex, check } from "drizzle-orm/pg-core";

/**
 * Ledger for deploy/oneoff/*.sh data scripts, written by deploy/oneoff/ledger.mjs
 * (not by the app). Declared here so drizzle-kit push/generate know the table
 * exists and never try to drop it. Created by migrations/0144_deploy_oneoff_runs.sql.
 */
export const deployOneoffRuns = pgTable(
  "deploy_oneoff_runs",
  {
    id: serial("id").primaryKey(),
    scriptName: text("script_name").notNull(),
    environment: text("environment").notNull(),
    mode: text("mode").notNull(), // 'dry-run' | 'apply'
    status: text("status").notNull(), // 'running' | 'succeeded' | 'failed'
    exitCode: integer("exit_code"),
    gitSha: text("git_sha"),
    scriptSha256: text("script_sha256"),
    host: text("host"),
    runBy: text("run_by"),
    logPath: text("log_path"),
    startedAt: timestamp("started_at").notNull().defaultNow(),
    finishedAt: timestamp("finished_at"),
  },
  (table) => ({
    appliedOnce: uniqueIndex("deploy_oneoff_runs_applied_once_uq")
      .on(table.scriptName, table.environment)
      .where(sql`${table.mode} = 'apply' AND ${table.status} = 'succeeded'`),
    envScriptIdx: index("deploy_oneoff_runs_env_script_idx").on(table.environment, table.scriptName),
    modeCheck: check("deploy_oneoff_runs_mode_check", sql`${table.mode} IN ('dry-run', 'apply')`),
    statusCheck: check("deploy_oneoff_runs_status_check", sql`${table.status} IN ('running', 'succeeded', 'failed')`),
  }),
);

export type DeployOneoffRun = typeof deployOneoffRuns.$inferSelect;
